module.exports = __webpack_public_path__ + "img/5.3f7d9c3c.png";